import { PermissionContext } from '../contexts/permissions.context';
import { useContext } from 'react';
import { UsePermissions } from '../types/UsePermissions';

export const usePermissions = (): UsePermissions => {
    return useContext<UsePermissions>(PermissionContext);
};